import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import dayjs from 'dayjs';

export const CATALOGO_CONCEPTOS = {
  ingreso: [
    { codigo: 'haber_basico', descripcion: 'Haber Básico', orden: 1 },
    { codigo: 'asig_familiar', descripcion: 'Asig. Familiar', orden: 2 },
    { codigo: 'horas_extras', descripcion: 'Horas Extras', orden: 3 },
    { codigo: 'dia_descanso_laborado', descripcion: 'Dia de Descanso Laborado', orden: 4 },
    { codigo: 'descanso_medico', descripcion: 'Descanso Médico', orden: 5 },
    { codigo: 'descanso_vacacional', descripcion: 'Descanso Vacacional', orden: 6 },
    { codigo: 'subsidio_maternidad', descripcion: 'Subsidio Maternidad Afecto', orden: 7 },
    { codigo: 'media_subvencion', descripcion: 'Media Subvención', orden: 8 },
    { codigo: 'compra_vacaciones', descripcion: 'Compra de vacaciones', orden: 9 },
    { codigo: 'bono_odo', descripcion: 'Bono ODO', orden: 10 },
    { codigo: 'bono_protocolo', descripcion: 'Bono protocolo', orden: 11 },
    { codigo: 'indemnizacion_vacaciones', descripcion: 'Indemnizacion Vacaciones', orden: 12 },
    { codigo: 'bonificacion_extraordinaria', descripcion: 'Bonificación extraordinaria', orden: 13 },
    { codigo: 'bono_cuidado', descripcion: 'Bono de cuidado de', orden: 14 },
    { codigo: 'otros_subsidios', descripcion: 'Otros Subsidios No Afectos', orden: 15 },
    { codigo: 'bono_productividad', descripcion: 'Bono por Productividad', orden: 16 },
    { codigo: 'bonificacion_aseo', descripcion: 'Bonificacion x aseo', orden: 17 },
    { codigo: 'aguinaldos', descripcion: 'Aginaldos Navideños', orden: 18 },
    { codigo: 'otros_ingresos', descripcion: 'Otros ingresos No afectos', orden: 19 },
  ],
  descuento: [
    { codigo: 'snp', descripcion: 'SNP', orden: 1 },
    { codigo: 'spp', descripcion: 'SPP', orden: 2 },
    { codigo: 'ap_obligatorio', descripcion: 'Ap. Obligatorio', orden: 3 },
    { codigo: 'prima_seguro', descripcion: 'Prima de Seguro', orden: 4 },
    { codigo: 'comision_variable', descripcion: 'Comision Variable', orden: 5 },
    { codigo: 'renta_5ta', descripcion: 'Impues. Renta 5° Categ.', orden: 6 },
    { codigo: 'adelanto_media_subvencion', descripcion: 'Adelanto de Media Subvención', orden: 7 },
    { codigo: 'vacaciones_pagadas', descripcion: 'Vacaciones pagadas', orden: 8 },
    { codigo: 'adelantos', descripcion: 'Adelantos', orden: 9 },
    { codigo: 'prestamos', descripcion: 'Prestamos 4/5', orden: 10 },
    { codigo: 'faltas', descripcion: 'Faltas injustificada', orden: 11 },
    { codigo: 'tardanzas', descripcion: 'Tardanzas', orden: 12 },
    { codigo: 'otros_descuentos', descripcion: 'Otros descuentos', orden: 13 },
  ],
  aporte: [
    { codigo: 'essalud', descripcion: 'ESSALUD', orden: 1 },
  ],
};

export const MAPA_BONIFICACION_CONCEPTO = {
  'PROTOCOLO DE ODDO': 'bono_odo',
  'CUMPLIMIENTO DEL PROTOCOLO': 'bono_protocolo',
  'BONO DE LIMPIEZA DE GRUA': 'bonificacion_aseo',
  'BONO CUIDADO DE HERRAMIENTAS': 'bono_cuidado',
  'BONO DE PRODUCCION': 'bono_productividad',
  FERIADO: 'dia_descanso_laborado',
  'BONO EXTRAORDINARIO': 'bonificacion_extraordinaria',
  'HORAS EXTRA 25%': 'horas_extras',
  'HORAS EXTRA 35%': 'horas_extras',
};

const MESES = [
  '', 'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
  'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE',
];

export function plantillaConceptos(existing = []) {
  const byCodigo = {};
  (existing || []).forEach((c) => {
    byCodigo[c.codigo] = c;
  });

  const result = [];
  Object.entries(CATALOGO_CONCEPTOS).forEach(([grupo, items]) => {
    items.forEach((item) => {
      const found = byCodigo[item.codigo];
      result.push({
        grupo,
        codigo: item.codigo,
        descripcion: item.descripcion,
        orden: item.orden,
        monto: found ? parseFloat(found.monto || 0) : 0,
      });
    });
  });
  return result;
}

export function sumarGrupo(conceptos, grupo) {
  return (conceptos || [])
    .filter((c) => c.grupo === grupo)
    .reduce((sum, c) => sum + parseFloat(c.monto || 0), 0);
}

export function calcularTotales(conceptos) {
  const ingresos = sumarGrupo(conceptos, 'ingreso');
  const descuentos = sumarGrupo(conceptos, 'descuento');
  const aportes = sumarGrupo(conceptos, 'aporte');
  return {
    ingresos,
    descuentos,
    aportes,
    totalPagar: ingresos - descuentos,
    bonificaciones: ingresos - (conceptos.find((c) => c.codigo === 'haber_basico')?.monto || 0),
    montoBase: parseFloat(conceptos.find((c) => c.codigo === 'haber_basico')?.monto || 0),
  };
}

function fmtMoney(n) {
  const val = parseFloat(n || 0);
  return val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function fmtDate(d) {
  if (!d) return '';
  return dayjs(d).format('D/MM/YYYY');
}

function conceptosPorGrupo(conceptos, grupo) {
  return (conceptos || [])
    .filter((c) => c.grupo === grupo)
    .sort((a, b) => a.orden - b.orden);
}

function buildConceptRows(items, blankRows = 0) {
  let html = items
    .map(
      (item) => `
      <tr>
        <td class="concepto">${item.descripcion}</td>
        <td class="monto">${fmtMoney(item.monto)}</td>
      </tr>`
    )
    .join('');

  for (let i = 0; i < blankRows; i++) {
    html += `<tr><td class="concepto">&nbsp;</td><td class="monto">&nbsp;</td></tr>`;
  }
  return html;
}

export function buildBoletaHtml(liquidacion) {
  const conceptos = plantillaConceptos(liquidacion.conceptos || []);
  const totales = calcularTotales(conceptos);
  const ingresos = conceptosPorGrupo(conceptos, 'ingreso');
  const descuentos = conceptosPorGrupo(conceptos, 'descuento');
  const aportes = conceptosPorGrupo(conceptos, 'aporte');
  const mesNombre = MESES[parseInt(liquidacion.periodo_mes, 10)] || liquidacion.periodo_mes;
  const logo = liquidacion.empresa_logo_url
    ? `<img src="${liquidacion.empresa_logo_url}" alt="logo" class="logo" />`
    : '';

  const maxRows = Math.max(ingresos.length, descuentos.length + aportes.length + 4, 19);
  const blankIng = Math.max(0, maxRows - ingresos.length);
  const blankDesc = Math.max(0, maxRows - descuentos.length - aportes.length - 2);

  return `
  <div id="boleta-pago-print" style="width: 1000px; background: #fff; color: #000; font-family: Arial, Helvetica, sans-serif; padding: 18px; box-sizing: border-box;">
    <style>
      #boleta-pago-print * { box-sizing: border-box; }
      #boleta-pago-print table { border-collapse: collapse; width: 100%; }
      #boleta-pago-print .logo { max-height: 70px; max-width: 120px; object-fit: contain; }
      #boleta-pago-print .header { display: flex; align-items: center; gap: 16px; margin-bottom: 8px; }
      #boleta-pago-print .header-info { flex: 1; text-align: center; }
      #boleta-pago-print .header-info h1 { margin: 0; font-size: 18px; letter-spacing: 0.5px; }
      #boleta-pago-print .header-info p { margin: 2px 0; font-size: 11px; }
      #boleta-pago-print .titulo { text-align: center; font-size: 20px; font-weight: 700; margin: 8px 0 2px; }
      #boleta-pago-print .periodo { text-align: center; font-size: 13px; font-weight: 700; margin-bottom: 10px; }
      #boleta-pago-print .meta th { background: #1f4e79; color: #fff; font-size: 10px; padding: 4px 6px; border: 1px solid #000; text-align: center; }
      #boleta-pago-print .meta td { border: 1px solid #000; font-size: 11px; padding: 4px 6px; text-align: center; }
      #boleta-pago-print .cols { display: flex; gap: 0; margin-top: 8px; border: 1px solid #000; }
      #boleta-pago-print .col { flex: 1; border-right: 1px solid #000; }
      #boleta-pago-print .col:last-child { border-right: none; }
      #boleta-pago-print .col-head { background: #1f4e79; color: #fff; text-align: center; font-size: 12px; font-weight: 700; padding: 6px; border-bottom: 1px solid #000; }
      #boleta-pago-print .concepto { border-bottom: 1px solid #cfcfcf; padding: 3px 6px; font-size: 11px; width: 70%; }
      #boleta-pago-print .monto { border-bottom: 1px solid #cfcfcf; border-left: 1px solid #cfcfcf; padding: 3px 6px; font-size: 11px; text-align: right; width: 30%; }
      #boleta-pago-print .total-row td { background: #e8eef5; font-weight: 700; border-top: 1px solid #000; padding: 5px 6px; font-size: 11px; }
      #boleta-pago-print .firmas { display: flex; justify-content: space-between; margin-top: 48px; padding: 0 40px; }
      #boleta-pago-print .firma { width: 38%; text-align: center; border-top: 1px solid #000; padding-top: 6px; font-size: 12px; font-weight: 700; }
    </style>

    <div class="header">
      <div style="width:130px;text-align:left;">${logo}</div>
      <div class="header-info">
        <h1>${liquidacion.empresa_nombre || 'EMPRESA'}</h1>
        <p>RUC: ${liquidacion.empresa_ruc || '-'}</p>
        <p>${liquidacion.empresa_direccion || ''}</p>
      </div>
      <div style="width:130px;"></div>
    </div>

    <div class="titulo">BOLETA DE PAGO</div>
    <div class="periodo">MES DE ${mesNombre} DEL ${liquidacion.periodo_anio}</div>

    <table class="meta">
      <tr>
        <th>APELLIDOS Y NOMBRES</th>
        <th>DNI</th>
        <th>CARGO</th>
        <th>FECHA DE INGRESO</th>
        <th colspan="2">PERIODO VACACIONAL</th>
      </tr>
      <tr>
        <td>${liquidacion.nombre_completo || ''}</td>
        <td>${liquidacion.documento || ''}</td>
        <td>${liquidacion.cargo || ''}</td>
        <td>${fmtDate(liquidacion.fecha_ingreso)}</td>
        <td>${fmtDate(liquidacion.periodo_vacacional_inicio)}</td>
        <td>AL ${fmtDate(liquidacion.periodo_vacacional_fin)}</td>
      </tr>
      <tr>
        <th>CODIGO</th>
        <th>CATEGORIA</th>
        <th>SPP</th>
        <th>Cuspp</th>
        <th colspan="2">FECHA DE CESE</th>
      </tr>
      <tr>
        <td>${liquidacion.codigo_trabajador || ''}</td>
        <td>${liquidacion.categoria || 'EMPLEADO'}</td>
        <td>${liquidacion.sistema_pensionario || ''}</td>
        <td>${liquidacion.cuspp || '0'}</td>
        <td colspan="2">${fmtDate(liquidacion.fecha_cese)}</td>
      </tr>
      <tr>
        <th>DIAS LABORADOS</th>
        <th>N° HORAS LABORADAS</th>
        <th>N° HORAS EXTRAS</th>
        <th>N° DIAS SUBSIDIADOS</th>
        <th colspan="2">PERIODICIDAD</th>
      </tr>
      <tr>
        <td>${liquidacion.dias_laborados ?? 0}</td>
        <td>${liquidacion.horas_laboradas ?? 0}</td>
        <td>${liquidacion.horas_extras > 0 ? liquidacion.horas_extras : '-'}</td>
        <td>${liquidacion.dias_subsidiados ?? 0}</td>
        <td colspan="2">${liquidacion.periodicidad || 'MENSUAL'}</td>
      </tr>
    </table>

    <div class="cols">
      <div class="col">
        <div class="col-head">INGRESOS</div>
        <table>
          ${buildConceptRows(ingresos, blankIng)}
          <tr class="total-row">
            <td>TOTAL INGRESOS</td>
            <td class="monto">S/. ${fmtMoney(totales.ingresos)}</td>
          </tr>
        </table>
      </div>
      <div class="col">
        <div class="col-head">RETENCIONES Y DESCUENTOS</div>
        <table>
          ${buildConceptRows(descuentos, blankDesc)}
          <tr class="total-row">
            <td>TOTAL RETENC. Y DESCUENTOS</td>
            <td class="monto">S/. ${fmtMoney(totales.descuentos)}</td>
          </tr>
        </table>
      </div>
      <div class="col">
        <div class="col-head">APORTES DEL EMPLEADOR</div>
        <table>
          ${buildConceptRows(aportes, Math.max(0, maxRows - aportes.length - 2))}
          <tr class="total-row">
            <td>TOTAL A PAGAR</td>
            <td class="monto">S/. ${fmtMoney(totales.totalPagar)}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="firmas">
      <div class="firma">EMPLEADOR</div>
      <div class="firma">EMPLEADO</div>
    </div>
  </div>`;
}

export async function exportarBoletaPDF(liquidacion) {
  const wrapper = document.createElement('div');
  wrapper.style.position = 'fixed';
  wrapper.style.left = '-10000px';
  wrapper.style.top = '0';
  wrapper.style.zIndex = '-1';
  wrapper.innerHTML = buildBoletaHtml(liquidacion);
  document.body.appendChild(wrapper);

  try {
    await new Promise((resolve) => setTimeout(resolve, 400));
    const node = wrapper.querySelector('#boleta-pago-print');
    const canvas = await html2canvas(node, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      logging: false,
      backgroundColor: '#ffffff',
      windowWidth: node.scrollWidth,
      windowHeight: node.scrollHeight,
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = 210;
    const pageHeight = 297;
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const fileName = `Boleta_${liquidacion.numero_boleta || liquidacion.id}_${dayjs().format('YYYYMMDD')}.pdf`;
    pdf.save(fileName);
  } finally {
    document.body.removeChild(wrapper);
  }
}
